/* 维护边界：纯计算；不写价格、不信任 line properties 作为折扣资格。浏览器与 Node 测试共用。 */
((root) => {
  'use strict';
  const isGift = item => item.properties?._bixdo_gift === 'true';
  const key = (parent, campaign, id) => JSON.stringify([String(parent), campaign, String(id)]);
  function gifts(promotion, now = Date.now()) {
    if (!promotion?.campaign || (promotion.endsAt > 0 && promotion.endsAt * 1000 <= now)) return [];
    const seen = new Set();
    return (promotion.gifts || []).filter(g => {
      if (!Number.isSafeInteger(g.id) || g.id <= 0 || !Number.isSafeInteger(g.quantity) || g.quantity < 1 || g.quantity > 100 || seen.has(g.id)) return false;
      seen.add(g.id);
      return true;
    });
  }
  function additions(mainId, promotion, quantity = 1) {
    return gifts(promotion).filter(g => g.id !== mainId).map(g => ({
      id: g.id, quantity: g.quantity * quantity,
      properties: { _bixdo_gift: 'true', _bixdo_campaign: promotion.campaign, _bixdo_parent_variant: String(mainId) }
    }));
  }
  function plan(cart, rules) {
    const desired = new Map(), rates = new Map(), mainRules = new Map();
    for (const rule of rules) mainRules.set(String(rule.mainId), rule.promotion);
    for (const line of cart.items) {
      if (isGift(line) || line.selling_plan_allocation) continue;
      const promotion = mainRules.get(String(line.variant_id));
      for (const gift of gifts(promotion)) {
        if (String(gift.id) === String(line.variant_id)) throw new Error('A main variant cannot gift itself.');
        if (rates.has(gift.id) && rates.get(gift.id) !== gift.quantity) throw new Error('Conflicting gift ratios.');
        rates.set(gift.id, gift.quantity);
        const k = key(line.variant_id, promotion.campaign, gift.id);
        const item = desired.get(k) || additions(line.variant_id, promotion).find(i => i.id === gift.id);
        if (!desired.has(k)) item.quantity = 0;
        item.quantity += gift.quantity * line.quantity;
        if (!Number.isSafeInteger(item.quantity)) throw new Error('Invalid gift quantity.');
        desired.set(k, item);
      }
    }
    // 主商品不能同时是其他规则的赠品；否则原生 BXGY 数量池有歧义。
    for (const id of rates.keys()) if (mainRules.has(String(id)) && gifts(mainRules.get(String(id))).length) throw new Error('Gift/main roles overlap.');
    const updates = {}, missing = [], existing = new Map();
    for (const line of cart.items.filter(isGift)) {
      const k = key(line.properties._bixdo_parent_variant, line.properties._bixdo_campaign, line.variant_id);
      if (!desired.has(k)) { updates[line.key] = 0; continue; }
      if (!existing.has(k)) existing.set(k, []);
      existing.get(k).push(line);
    }
    for (const [k, item] of desired) {
      const lines = existing.get(k) || [];
      if (!lines.length) { missing.push(item); continue; }
      const total = lines.reduce((sum, line) => sum + line.quantity, 0);
      // Shopify 可以为同一组私有属性拆出不同折扣行；数量已匹配时不强行合并。
      if (total < item.quantity) updates[lines[0].key] = lines[0].quantity + item.quantity - total;
      if (total > item.quantity) {
        let remaining = item.quantity;
        for (const line of lines) {
          const quantity = Math.min(line.quantity, remaining);
          remaining -= quantity;
          if (line.quantity !== quantity) updates[line.key] = quantity;
        }
      }
    }
    return { updates, missing, desired: [...desired.values()] };
  }
  const api = { isGift, gifts, additions, plan };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.BixdoGiftEngine ||= api;
})(globalThis);
